// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Types
import type { ChartType } from '@/lib/analytics/charts/type';
import { SIZE_FULL } from '@/lib/gridElements/size';
import { FACEBOOK, INSTAGRAM, LINKEDIN, PINTEREST } from '@/lib/socialProfile';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const impressionsHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.group.views_impressions_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.group.views_impressions_history_name'
    },
    id: 'impressions_history',
    color: {
        value: 'purple'
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_FULL,
    type: 'chart',
    isXAxisDate: true,
    element: LineChart,
    hasComparativeView: true,
    aggregatedNetworks: [INSTAGRAM, FACEBOOK, LINKEDIN, PINTEREST]
};
